import React from 'react';
import { Badge } from 'antd';
import PropTypes from 'prop-types';
import { Flex, Icon, DropdownButton } from 'ui';
import { withRouter } from 'utils/withRouter';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { viewConfig } from '../../common/gantt/config';
import { myUnpublishedItemsViewId } from '../../utils/app-configs';

const SortFlex = styled(Flex)`
  border-left: 1px solid ${p => p.theme.colors.border};
  padding-left: 15px;
  padding-left: 15px;
  margin-right: 15px;
`;

const StyledBadge = styled(Badge)`
  .ant-badge-count {
    background: ${p => p.hasError ? p.theme.colors.publishSteps.error : '#fff'};
    color: ${p => p.hasError ? '#fff' : '#6f7e95'};
    box-shadow: 0 0 0 1px ${p => p.hasError ? p.theme.colors.publishSteps.error : '#fff'};
    height: 15px;
    line-height: 15px;
    margin-left: 8px;
    margin-top: -2px;
  }

  .ant-badge-multiple-words {
    padding: 0 5px;
  }
`;

const StyledExchangeIcon = styled(Icon)`
  margin-right: 5px;
  color: white !important;
`;

const StyledErrorIcon = styled(Icon)`
  margin-right: 5px;
  --fa-primary-color: #fff;
  --fa-secondary-color: ${p => p.theme.colors.publishSteps.error};
  --fa-secondary-opacity: 1;
`;

const PublishButton = ({
  totalCount = 0,
  totalErrorCount = 0,
  isLoading = false,
  publishAllToSAP,
  isCreating,
  isLoadingPublishButton,
  views = [],
  updateView,
  intl,
}) => {
  const handlePublish = () => {
    publishAllToSAP({
      boardId: viewConfig.boardIdTypes.service,
    });
  };

  const handleShowUnpublished = () => {
    const myUnpublishedView = views?.find(v =>
      v.friendlyUid?.toLowerCase() === myUnpublishedItemsViewId?.toLowerCase(),
    );

    if (myUnpublishedView) {
      updateView(myUnpublishedView);
    }
  };

  const dropdownActions = [
    {
      text: intl.formatMessage({ id: 'planningBoard.blocks.PUBLISH_TO_SAP' }),
      onClick: handlePublish,
    },
    {
      text: intl.formatMessage({ id: 'planningBoard.SHOW_UNPUBLISHED_ITEMS' }),
      onClick: handleShowUnpublished,
    },
  ];

  const badgeCount =
    totalCount && totalErrorCount ?
      `${totalErrorCount}/${totalCount}` :
      totalCount || totalErrorCount || 0;

  return (
    <SortFlex>
      <DropdownButton
        type='secondary'
        onClick={handlePublish}
        subItems={dropdownActions}
        text={
          <>
            {totalErrorCount ?
              <StyledErrorIcon type='circle-exclamation' className='fa-duotone' size='lg' /> :
              <StyledExchangeIcon type='exchange-alt' />
            }
            <span>
              <FormattedMessage id='planningBoard.blocks.PUBLISH_TO_SAP' />
            </span>
            <StyledBadge showZero={true} count={badgeCount} hasError={!!totalErrorCount} />
          </>
        }
        disabled={
          isLoading ||
          isCreating ||
          isLoadingPublishButton ||
          (!totalCount && !totalErrorCount)
        }
      />
    </SortFlex>
  );
};

PublishButton.propTypes = {
  isLoading: PropTypes.bool,
  isCreating: PropTypes.bool,
  publishAllToSAP: PropTypes.func,
  totalCount: PropTypes.number,
  totalErrorCount: PropTypes.number,
  isLoadingPublishButton: PropTypes.bool,
  intl: PropTypes.object,
  views: PropTypes.array,
  updateView: PropTypes.func,
};

export default injectIntl(withRouter(PublishButton));
